<template>
	<div class="vertical-menu" v-if="!dontPrint.find(x => x === $route.path)">
		<template v-for="item in routes" :key="item.link">
			<MenuItem v-if="item.print !== false" :path="item.path" :name="item.name" @clicked="$emit('clicked')" />
		</template>
	</div>
</template>

<script>

import { getConfig } from '@/auth'
import MenuItem from './MenuItem.vue';
const basePath = getConfig().basePath

export default {
	props: ['routes'],
	emits: ['clicked'],
	data() {
		return {
			basePath,
			dontPrint: [basePath + '/table', basePath + '/users'],
		};
	},
	components: { MenuItem }
}
</script>

<style>
.vertical-menu {
	background-color: white;
	width: 100%;
}
</style>